export default __webpack_public_path__ + "static/media/edit.f5008248.svg";